import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getCustomGeoZonesCategories(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES,
		ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].GET_CUSTOM_GEO_ZONES_CATEGORIES,
		options
	)
}

function _createCustomGeoZoneCategory(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES,
		ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].CREATE_CUSTOM_GEO_ZONES_CATEGORY,
		options
	)
}

function _getCustomGeoZoneCategory(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES,
		ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].GET_CUSTOM_GEO_ZONES_CATEGORY,
		options
	)
}

function _patchCustomGeoZoneCategory(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES,
		ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].PATCH_CUSTOM_GEO_ZONES_CATEGORY,
		options
	)
}

function _putCustomGeoZoneCategory(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES,
		ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].PUT_CUSTOM_GEO_ZONES_CATEGORY,
		options
	)
}

function _deleteCustomGeoZoneCategory(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES,
		ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].DELETE_CUSTOM_GEO_ZONES_CATEGORY,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].GET_CUSTOM_GEO_ZONES_CATEGORIES]: _getCustomGeoZonesCategories,
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].GET_CUSTOM_GEO_ZONES_CATEGORY]: _getCustomGeoZoneCategory,
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].CREATE_CUSTOM_GEO_ZONES_CATEGORY]: _createCustomGeoZoneCategory,
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].PUT_CUSTOM_GEO_ZONES_CATEGORY]: _putCustomGeoZoneCategory,
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].PATCH_CUSTOM_GEO_ZONES_CATEGORY]: _patchCustomGeoZoneCategory,
	[ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].DELETE_CUSTOM_GEO_ZONES_CATEGORY]: _deleteCustomGeoZoneCategory,
}
